/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { DeeplinkRequestApiDto } from '../model/deeplink-request.model';
// @ts-ignore
import { DeeplinkResponseApiDto } from '../model/deeplink-response.model';
// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';
// @ts-ignore
import { QuoteApiDto } from '../model/quote.model';
// @ts-ignore
import { QuoteInputApiDto } from '../model/quote-input.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { QuotesControllerApiServiceInterface } from './quotes-controller.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class QuotesControllerApiService extends BaseService implements QuotesControllerApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param deeplinkRequestApiDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateDeeplink(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    deeplinkRequestApiDto: DeeplinkRequestApiDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<DeeplinkResponseApiDto>;
  public generateDeeplink(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    deeplinkRequestApiDto: DeeplinkRequestApiDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<DeeplinkResponseApiDto>>;
  public generateDeeplink(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    deeplinkRequestApiDto: DeeplinkRequestApiDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<DeeplinkResponseApiDto>>;
  public generateDeeplink(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    deeplinkRequestApiDto: DeeplinkRequestApiDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling generateDeeplink.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling generateDeeplink.');
    }
    if (deeplinkRequestApiDto === null || deeplinkRequestApiDto === undefined) {
      throw new Error('Required parameter deeplinkRequestApiDto was null or undefined when calling generateDeeplink.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/quotes/v1/deeplinks`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<DeeplinkResponseApiDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: deeplinkRequestApiDto,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param quoteInputApiDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public requestQuoteFromPricingDomain(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<QuoteApiDto>;
  public requestQuoteFromPricingDomain(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<QuoteApiDto>>;
  public requestQuoteFromPricingDomain(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<QuoteApiDto>>;
  public requestQuoteFromPricingDomain(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling requestQuoteFromPricingDomain.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling requestQuoteFromPricingDomain.');
    }
    if (quoteInputApiDto === null || quoteInputApiDto === undefined) {
      throw new Error('Required parameter quoteInputApiDto was null or undefined when calling requestQuoteFromPricingDomain.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/quotes/v2/pricing-quote`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<QuoteApiDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: quoteInputApiDto,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param quoteInputApiDto
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public requestQuoteV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<QuoteApiDto>;
  public requestQuoteV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpResponse<QuoteApiDto>>;
  public requestQuoteV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<HttpEvent<QuoteApiDto>>;
  public requestQuoteV2(
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    quoteInputApiDto: QuoteInputApiDto,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json' | '*/*'; context?: HttpContext },
  ): Observable<any> {
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling requestQuoteV2.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling requestQuoteV2.');
    }
    if (quoteInputApiDto === null || quoteInputApiDto === undefined) {
      throw new Error('Required parameter quoteInputApiDto was null or undefined when calling requestQuoteV2.');
    }

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json', '*/*']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/quotes/v2/quote-prices`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<QuoteApiDto>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: quoteInputApiDto,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
